import { pauseTracking, resetTracking } from "@vue/reactivity";
import { type Ref, toValue } from "vue";

/**
 * access ref values without marking the ref as a watcher dependency
 * @param refOrGetter ref or getter accessing a ref
 * @returns the value of ref
 */
export const untrack: {
  <T>(ref: Ref<T>): T;
  <T>(getter: () => T): T;
} = (refOrGetter: Ref<any> | (() => any)): any => {
  try {
    pauseTracking();
    return toValue(refOrGetter);
  } finally {
    resetTracking();
  }
};
